import React from 'react'
import Rules from '../Component/Rules'
import Navbar from '../Component/Navbar'
import Footer from '../Component/Footer'
import Curousel from '../Component/Curousel';

function Rule() {
  return (
    <div>
        <Navbar/>
    <Curousel/>
        <Rules/>
        <Footer/>
    </div>
  )
}

export default Rule
